import {ProfilePicture} from './profile_picture';

export default ProfilePicture;
